'use strict';

angular.module('atex.dam').factory('DamResolveService', [
  '$rootScope', '$q', 'ContentService', 'ContentCacheService',
  function($rootScope, $q, ContentService, ContentCacheService) {
    var promiseMap = {};

    $rootScope.$on("dam:logout", function() {
      promiseMap = undefined;
    });

    var washContentId = function (id) {
      return id.replace('contentid/', '');
    };

    var asExternalId = function (id) {
      if (!id.startsWith('externalid/')) {
        return 'externalid/' + id;
      }
      return id;
    };

    var prefixedContentId = function (id) {
      if (id.startsWith('contentid/') || id.startsWith('externalid/')) {
        return id;
      } else if (id.startsWith('policy:') || id.startsWith('onecms:') || id.startsWith('draft:')) {
        return 'contentid/' + id;
      } else {
        return asExternalId(id);
      }
    };

    var getExternalId = function(id) {
      var washedId = washContentId(id);
      var key = "extid-" + washedId;
      return ContentCacheService.get(key, function () {
          var p = promiseMap[washedId];
          if (!p) {
            p = ContentService.getContent({id: prefixedContentId(id)})
              .then(function(content) {
                return atex.onecms.ObjectUtils.getByPath(content, "data/aspects/atex.Aliases/data/aliases/externalId");
              }, function (error) {
                console.log('error fetching ' + id, error);
                return error;
              });
            promiseMap[washedId] = p;
          }
          return p;
        }
      );
    };

    return {
      getExternalId: getExternalId
    };
  }
]);
